import FeeDescriptionSectionController from 'Components/site/parts/facility/fee_description_modal/common/section_controller'

// 費目解説モーダルを開く処理は料金プランセクションと共通（基底クラス側）。
// このセクション固有の挙動は無いため、識別子の登録のためだけに継承する。
export default class extends FeeDescriptionSectionController {}
